import { api, authFetch } from './client'
import type {
  LlmGenerateRequest,
  LlmGenerateResponse,
  LlmUsageStats,
  SharedTemplateDto,
} from './types'

export const llmApi = {
  generate: (body: LlmGenerateRequest) =>
    api<LlmGenerateResponse>('/llm/generate', {
      method: 'POST',
      body: JSON.stringify(body),
    }),

  usage: () => api<LlmUsageStats>('/llm/usage'),

  /** Vision: multipart с image + prompt. Auth — httpOnly cookie. */
  vision: async (prompt: string, image: File): Promise<LlmGenerateResponse> => {
    const fd = new FormData()
    fd.append('prompt', prompt)
    fd.append('image', image)
    const resp = await authFetch('/llm/vision', { method: 'POST', body: fd })
    const text = await resp.text()
    const body = text ? JSON.parse(text) : null
    if (!resp.ok) throw new Error(body?.message || `HTTP ${resp.status}`)
    return body as LlmGenerateResponse
  },
}

export const templatesApi = {
  list: (schoolId: string, since = 0) =>
    api<SharedTemplateDto[]>(`/schools/${schoolId}/templates?since=${since}`),
}
